export const SET_MARKETING_CAMPAIGNS = "SET_MARKETING_CAMPAIGNS"
